import { Fragment } from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TopTitle } from '../components/atoms/TopTitle'

export function EmptyPage(): React.ReactElement {
  const { t } = useTranslation()

  return (
    <Fragment>
      <TopTitle title={t('Not Implemented')}/>
      <Box>
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      </Box>
    </Fragment>
  )
}
